export default {
    columns: [
        {
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.activity.id.description",//"Código interno actividad",
          label:"wkt.admin.qbuilder.model.activity.id.text",//"Código actividad",
          field: "id"
        },
        {
          field: "activityStart",
          type: "DATETIME",
          desc:"wkt.admin.qbuilder.model.activity.start.description",//"Inicio actividad",
          label:"wkt.admin.qbuilder.model.activity.start.text",//"Inicio actividad",
          formatter: 'formatDateTime'
        },
        {
          field: "activityStartLocal",
          type: "DATETIME",
          desc:"wkt.admin.qbuilder.model.activity.start-local.description",//"Inicio actividad local",
          label:"wkt.admin.qbuilder.model.activity.start-local.text",//"Inicio actividad local",
          formatter: 'formatDateTimeLocal'
        },
        {
          field: "activityStartDeviceType",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.start_device_type.description",  // "Dispositivo inicio",
          label:"wkt.admin.qbuilder.model.activity.start_device_type.text",         // "Dispositivo inicio",
          formatter: 'formatChoice',
          choices: [ { 'key':'WEB', 'value':'wkt.admin.qbuilder.model.activity.device_type.web' /*'Web'*/ },
                     { 'key':'APP', 'value':'wkt.admin.qbuilder.model.activity.device_type.app' /*'Movil'*/ },
                     { 'key':'KIOSCO', 'value':'wkt.admin.qbuilder.model.activity.device_type.kiosco' /*'Kiosco'*/ } ,
                     { 'key':'WHATSAPP', 'value':'wkt.admin.qbuilder.model.activity.device_type.whatsapp' /*'WhatsApp'*/ } ]
        },
        {
          field: "activityFinish",
          type: "DATETIME",
          desc:"wkt.admin.qbuilder.model.activity.finish.description",//"Fin actividad",
          label:"wkt.admin.qbuilder.model.activity.finish.text",//"Fin actividad",
          formatter: 'formatDateTime'
        },
        {
          field: "activityFinishLocal",
          type: "DATETIME",
          desc:"wkt.admin.qbuilder.model.activity.finish-local.description",//"Fin actividad local",
          label:"wkt.admin.qbuilder.model.activity.finish-local.text",//"Fin actividad local",
          formatter: 'formatDateTimeLocal'
        },
        {
          field: "activityFinishDeviceType",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.finish_device_type.description",  // "Dispositivo fin",
          label:"wkt.admin.qbuilder.model.activity.finish_device_type.text",         // "Dispositivo fin",
          formatter: 'formatChoice',
          choices: [ { 'key':'WEB', 'value':'wkt.admin.qbuilder.model.activity.device_type.web' /*'Web'*/ },
                     { 'key':'APP', 'value':'wkt.admin.qbuilder.model.activity.device_type.app' /*'Movil'*/ },
                     { 'key':'KIOSCO', 'value':'wkt.admin.qbuilder.model.activity.device_type.kiosco' /*'Kiosco'*/ },
                     { 'key':'WHATSAPP', 'value':'wkt.admin.qbuilder.model.activity.device_type.whatsapp' /*'WhatsApp'*/ } ]
        },
        {
          field: "activityTime",
          type: "TIME",
          desc:"wkt.admin.qbuilder.model.activity.time.description",//"Duración de la actividad",
          label:"wkt.admin.qbuilder.model.activity.time.text",//"Duración",
          formatter: 'formatTime'
        },
        {
          field: "activityTimeHours",
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.activity.time_hours.description",//"Duración en horas de la actividad",
          label:"wkt.admin.qbuilder.model.activity.time_hours.text",//"Duración en horas"
          formatter: 'formatFloat'
        },
        {
          field: "activityTypeId",
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.activity.type-id.description",//"Código tipo de actividad",
          label:"wkt.admin.qbuilder.model.activity.type-id.text",//"Código tipo",
        },
        {
          field: "activityTypeDescription",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.type.description",//"Tipo de actividad",
          label:"wkt.admin.qbuilder.model.activity.type.text",//"Tipo actividad",
        },
        {
          field: "activityTypeReference",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.type-reference.description",//"Referencia del tipo de actividad",
          label:"wkt.admin.qbuilder.model.activity.type-reference.text",//"Referencia actividad",
        },
		{
          field: "description",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.desc.description",//"Referencia del tipo de actividad",
          label:"wkt.admin.qbuilder.model.activity.desc.text",//"Referencia actividad",
        },
        {
          field: "workable",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.activity.workable.description",//"Categoría de la actividad",
          label:"wkt.admin.qbuilder.model.activity.workable.text",//"Categoría",
          formatter: 'formatChoice',
          choices: [ { 'key':'1', 'value':'wkt.admin.qbuilder.model.activity.choice.work'/*'Laboral'*/ },
                     { 'key':'0', 'value':'wkt.admin.qbuilder.model.activity.choice.personal'/*'Personal'*/ } ]
        },
        {
          field: "workdayId",
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.activity.workday-id.description",//"Código de la jornada",
          label:"wkt.admin.qbuilder.model.activity.workday-id.text",//"Código de la jornada"
        },
        {
          field: "workdayDate",
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.activity.workday-date.description", //"Fecha de la jornada",
          label: "wkt.admin.qbuilder.model.activity.workday-date.text",  //"Fecha de la jornada",
          formatter: 'formatSimpleDate'
        },
        {
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.company-notes.description",//"Notas para el trabajador",
          label:"wkt.admin.qbuilder.model.activity.company-notes.text",//"Notas para el trabajador",
          field: "workdayCompanyNotes"
        },
        {
          field: "employeeId",
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.activity.employee-id.description",//"Codigo interno del trabajador",
          label:"wkt.admin.qbuilder.model.activity.employee-id.text",//"Código trabajador",
        },
        {
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.employee-firstname.description",//"Nombre del trabajador",
          label:"wkt.admin.qbuilder.model.activity.employee-firstname.text",//"Nombre",
          field: "firstname"
        },
        {
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.employee-lastname.description",//"Apellidos del trabajador",
          label:"wkt.admin.qbuilder.model.activity.employee-lastname.text",//"Apellidos",
          field: "lastname"
        },
        {
          field: "username",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.username.description",//"Nombre de usuario",
          label:"wkt.admin.qbuilder.model.activity.username.text",//"Usuario"
        },
        {
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.employee-idNumber.description",//"Documento identificativo del trabajador",
          label:"wkt.admin.qbuilder.model.activity.employee-idNumber.text",//"Documento ID",
          field: "idNumber"
        },
        {
          field: "employeeReference",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.employee-reference.description",//"Referencia del trabajador",
          label:"wkt.admin.qbuilder.model.activity.employee-reference.text",//"Referencia trabajador"
        },
        {
          field: "projectId",
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.activity.project-id.description",//"Código interno de proyecto",
          label:"wkt.admin.qbuilder.model.activity.project-id.text",//"Código proyecto"
        },
        {
          field: "projectName",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.project-name.description",//"Nombre del proyecto",
          label:"wkt.admin.qbuilder.model.activity.project-name.text",//"Proyecto"
        },
        {
          field: "projectReference",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.project-reference.description",//"Referencia del proyecto",
          label:"wkt.admin.qbuilder.model.activit.project-reference.text",//"Referencia proyecto"
        },
        {
          field: "workplaceId",
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.activity.workplace-id.description",//"Código del centro de trabajo",
          label:"wkt.admin.qbuilder.model.activity.workplace-id.text",//"Código centro trabajo"
        },
        {
          field: "workplaceName",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.workplace-name.description",//"Nombre Centro de trabajo",
          label:"wkt.admin.qbuilder.model.activity.workplace-name.text",//"Centro trabajo"
        },
        {
          field: "departmentId",
          type: "NUMERIC",
          desc:"wkt.admin.qbuilder.model.department-id.description",//"Código del departamento",
          label:"wkt.admin.qbuilder.model.department-id.text",//"Código departamento"
        },
        {
          field: "departmentName",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.department-name.description",//"Nombre Departamento",
          label:"wkt.admin.qbuilder.model.activity.department-name.text",//"Departamento"
        },
        {
          field: "updated",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.activity.updated.description",//"Actividad modificada",
          label:"wkt.admin.qbuilder.model.activity.updated.text",//"Modificado",
          formatter: 'formatChoice',
          choices: [ { 'key':'1', 'value':'wkt.admin.common.yes'/*'Si'*/ },
                     { 'key':'0', 'value':'wkt.admin.common.no'/*'No'*/ } ]
        },
        {
          field: "activityModality",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.activity.modality.description",//'Modalidad de la actividad',
          label: "wkt.admin.qbuilder.model.activity.modality.text",//'Modalidad',
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.qbuilder.model.activity.modality.office'/*'Presencial'*/ },
                     { 'key':'1', 'value':'wkt.admin.qbuilder.model.activity.modality.telework'/*'Teletrabajo'*/ } ]
        },
        {
          field: "isEnabled",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.enabled.description",    //"Habilitado",
          label: "wkt.admin.qbuilder.model.employee.enabled.text",  //"Habilitado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        }
      ],
}